import ManagedUsersRoute from '@/features/me/managed-users/ManagedUsersRoute.tsx';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/me/notifications/managed')({
  component: ManagedUsersRoute,
});
